/**
 * Team Insights API — subordinate test results + IDP aggregate for managers.
 */

import { apiFetch } from './core'

export const teamInsights = {
    tests: (params = {}) => {
        const qs = new URLSearchParams()
        if (params.department_id) qs.set('department_id', params.department_id)
        const q = qs.toString()
        return apiFetch(`/team-insights/tests${q ? `?${q}` : ''}`)
    },
    employeeDetail: (employeeId) => apiFetch(`/team-insights/tests/${employeeId}`),
    // Wave 1.5 PR-5 — KB restudy overdue dashboard для senior_online_manager.
    // Возвращает employee'ев со ack study_status ∈ pending/studying/test_failed,
    // assigned >7 дн назад.
    kbRestudyOverdue: () => apiFetch('/team-insights/kb-restudy-overdue'),
    // Wave 2 PR-5 — Trainer-vs-Real scatter calibration. Доступ через
    // team.insights.read. Возвращает per-manager точки (trainer pass-rate
    // vs PS2 conversion) + aggregate Spearman ρ (когда N ≥ 5).
    trainerVsReal: (periodDays = 7) =>
        apiFetch(`/team-insights/trainer-vs-real?period_days=${encodeURIComponent(periodDays)}`),
    // Wave 3 PR-5 — Team Readiness Grid (N×7 heatmap по journey_step).
    // Доступ через team.insights.read. Опциональный department_id фильтрует
    // выдачу внутри scope viewer'а (не расширяет scope).
    readinessGrid: ({ department_id } = {}) => {
        const qs = new URLSearchParams()
        if (department_id) qs.set('department_id', department_id)
        const q = qs.toString()
        return apiFetch(`/team-insights/readiness-grid${q ? `?${q}` : ''}`)
    },
    // v3 Phase 6 — 4-axis dialogue readiness composite per employee.
    dialogueReadiness: (periodDays = 30) =>
        apiFetch(`/team-insights/dialogue-readiness?period_days=${encodeURIComponent(periodDays)}`),
}

// Wave 2 PR-5 — личный «Вчерашний разбор» (Self-View). Owner-only.
// Если date не передан — backend подставит вчера UTC.
export const morningDebrief = {
    fetch: (date) => {
        const q = date ? `?date=${encodeURIComponent(date)}` : ''
        return apiFetch(`/me/morning-debrief${q}`)
    },
}

// Wave 3 PR-6 — личная калибровка тренажёра (Self-View). Owner-only.
// Backend GET /api/v1/me/calibration?period_days=7|30|90 — фильтр по
// current_user.employee_id, чужие данные утечь не могут (нет employee_id-параметра).
export const myCalibration = {
    fetch: (periodDays = 7) =>
        apiFetch(`/me/calibration?period_days=${encodeURIComponent(periodDays)}`),
}
